import React, { useState, useEffect, useRef, forwardRef } from "react";
import { API_AUTH } from "service/common";
import ReactToPrint, {
  PrintContextConsumer,
  useReactToPrint,
} from "react-to-print";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import ThuChiNgoaiLePrint from "components/GenericComponent/ContentPrint/ThuChiNgoaiLePrint";
import ThuChiHopDongPrint from "components/GenericComponent/ContentPrint/ThuChiHopDongPrint";
import NoPhaiThuPrint from "components/GenericComponent/ContentPrint/NoPhaiThuPrint";
export const PrintDataContent = ({ link, loai }) => {
  const [dataPrint, setDataPrint] = useState({});
  const componentRef = useRef();
  const print = () => {
    //  handleShow();
    API_AUTH.get(link).then((res) => {
      setDataPrint(res.data);
      setTimeout(handlePrint(), 1000);
      //setTimeout(handleClose(), 5000);
    });
    // alert(loai);
    // setTimeout(handlePrint(), 2000);
  };
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  // const [show, setShow] = useState(false);
  // const handleClose = () => setShow(false);
  // const handleShow = () => setShow(true);

  return (
    <>
      <a onClick={print} className="icon-bgnew color-print1">
        <PopoversBootrap
          contentText="In danh sách"
          trigger={["hover", "focus"]}
          placement={"top"}
        >
          <img src="/app-assets/images/icon-print.png"/>
        </PopoversBootrap>
      </a>

      <div>
        <div style={{ display: "none", color: "#000000" }}>
          {loai !== undefined && loai === "ThuNgoaiLePrint" && (
            <ThuChiNgoaiLePrint ref={componentRef} dataPrint={dataPrint} />
          )}
          {loai !== undefined && loai === "ThuChiHopDongPrint" && (
            <ThuChiHopDongPrint ref={componentRef} dataPrint={dataPrint} />
          )}
          {loai !== undefined && loai === "NoPhaiThuPrint" && (
            <NoPhaiThuPrint ref={componentRef} dataPrint={dataPrint} />
          )}
        </div>
      </div>
      {/* {show &&(
        <>
 <div style={{width:"100%", height:"100%",margin: "0 auto", opacity:"0.7" ,backgroundColor:"#EEE", position:"fixed", zIndex:"999", top:"0",left:"0", bottom:"0",right:"0"}} id="loadPrint">
 </div>
 <div style={{width:"300px",margin: "0 auto", zIndex:"9999", color:"#555", position:"fixed", top:"50%",left:"50%"}}>Phần mềm đang tải dữ liệu. Vui lòng chờ trong giây lát.</div>
 </>
      )}
      */}
    </>
  );
};
// <ComponentToPrint ref={componentRef} content={content} />
class ComponentToPrint extends React.Component {
  render() {
    return (
      <div
        style={{ width: "100%", padding: "10px" }}
        dangerouslySetInnerHTML={{ __html: this.props.content }}
      />
    );
  }
}

// import React from "react";
// import ReactToPrint from "react-to-print";
// import { API_AUTH } from "service/common";
// class PrintData extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       printContent: props.contentPrint,
//       link: "",
//       show:props.show,
//     };
//   //  alert(props.contentPrint)
//   //let printRef = useRef();
//   }

//   componentDidMount() {
//     alert(1)
//     let { link,show } = this.props;
//     API_AUTH.get(link).then((res) => {
//       this.setState({ printContent: res.data });
//     });
//     show=false;
//    // this.componentRef.current.handleClick();
//   }
//   componentDidUpdate(preState, preProps) {
//     let { link } = this.props;
//     if (preState.link !== link) {
//       this.setState({ link: link });
//       API_AUTH.get(link).then((res) => {
//         this.setState({ printContent: res.data });
//       });
//     }
//   }

//   render() {
//     let { printContent } = this.state;
//     return (
//       <div>
//         {/* <ReactToPrint
//           trigger={() => (
//             <a href={() => false}  className="icon-bgnew color-print1" >
//               <i className="mdi mdi-printer"></i>
//             </a>
//           )}
//           content={() => this.componentRef}
//           copyStyles={false}
//         /> */}
//         <ReactToPrint
//         trigger={() => <React.Fragment/>}
//         content={() => this.componentRef}
//        // ref={printRef}
//       />
//         <div style={{ display: "none" }}>
//           <div ref={(el) => (this.componentRef = el)}>
//             <div
//               style={{ width: "100%", color: "#000000", padding: "10px" }}
//               dangerouslySetInnerHTML={{ __html: printContent }}
//             ></div>
//           </div>
//         </div>
//       </div>
//     );
//   }
// }
// export default PrintData;
